
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, forwardRef, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, inject } from "@angular/core";
import { TaskOptionComponent } from "../task-option.component";
import { TaskUtils } from "../../../../shared/task-utils";
import { TaskRepository } from "../../../../repository/task.repository";
import { DateFilterType } from "../../../../shared/task-enum";
import { DateType } from "../../../../models";
import { MatDialog } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatList, MatListItem } from "@angular/material/list";
import { TranslatePipe } from "@ngx-translate/core";
import { LocaleDatePipe } from "../../../pipes/locale-date.pipe";

@Component({
    selector: "vp-vnctask-option-start-date",
    providers: [{
            provide: TaskOptionComponent,
            // eslint-disable-next-line
            useExisting: forwardRef(() => TaskStartDateOptionComponent)
        }],
    templateUrl: "option-start-date.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, MatList, MatListItem, TranslatePipe, LocaleDatePipe]
})
export class TaskStartDateOptionComponent extends TaskOptionComponent implements OnInit {
  private taskRepo = inject(TaskRepository);
  override changerDetectorRef: ChangeDetectorRef;
  override matDialog: MatDialog;

  override id: string = "add-start-date";
  override triggerKey = "~";
  dateType = DateType.START_DATE;
  constructor() {
    const changerDetectorRef = inject(ChangeDetectorRef);
    const matDialog = inject(MatDialog);

    super();

    this.changerDetectorRef = changerDetectorRef;
    this.matDialog = matDialog;
  }

  ngOnInit() {
    let items = this.taskRepo.getDateFilterItems(DateFilterType.StartDate);
    this.setItems(items);
  }

  override getPayload() {
    let value = this.getValue();
    if (!value || (value && !value.date)) {
      return { start_date: ""};
    }
    return { start_date: TaskUtils.getFormattedDate(value.date) };
  }

}